<template>
  <div class="finder-container" v-if="question">
    <ProgressBar :progress="progress" />

    <div class="finder-background" :style="`background-image: url(${require('@/assets/img/backgrounds/finder.png')});`">
      <transition name="fade" mode="out-in">
        <Results :results="$store.state.finder.results" v-bind:key="0" v-if="$store.state.finder.results" />

        <div class="container container--small" v-bind:key="question.id" v-else>
          <Question
            v-bind="question"
            v-on:next="(id) => chooseQuestion(id)"
            v-on:result="(result) => showResults(result)"
          />

          <Details v-bind="question.details" v-if="question.details" />
          <transition-group name="slide" mode="out-in" appear>
            <Answer
              v-for="(answer, index) in question.answers"
              v-bind:key="`answer-${index}`"
              v-bind="answer"
              v-on:selectAnswer="(type, value) => selectAnswer(type, value)"
              :style="`transition-delay: ${index / 5}s;`"
            />
          </transition-group>

        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import ProgressBar from '@/components/finder/ProgressBar.vue';
import Results from '@/components/finder/Results.vue';
import Question from '@/components/finder/Question.vue';
import Answer from '@/components/finder/Answer.vue';
import Details from '@/components/finder/Details.vue';

export default {
  components: {
    ProgressBar,
    Results,
    Question,
    Answer,
    Details,
  },
  data() {
    return {
      progress: 0,
      question: null,
    };
  },
  methods: {
    chooseQuestion(id) {
      // Update variables
      this.$store.dispatch('setCurrentId', id);
      this.question = this.$store.state.questions[id];
    },

    setProgressBar(amount) {
      this.progress = Math.ceil(amount);
    },

    selectAnswer(type, value) {
      // Update revert history
      this.$store.dispatch('historyAdd', this.$store.state.finder.currentId);

      // Next question or show results
      if (type === 'next') {
        // Select question
        this.chooseQuestion(value);

        // Increase progress bar
        const progressAmount = Math.ceil(this.question.remaining === 0 ? 90 : 100 / this.question.remaining);
        this.setProgressBar(progressAmount);
      } else if (type === 'results') {
        this.$store.dispatch('setResults', value);

        // Set progress to 100% because we are finished
        this.setProgressBar(100);
      }
    },

    showResults(result) {
      this.$store.dispatch('setResults', result);
    },
  },
  mounted() {
    // Select first question
    this.chooseQuestion(this.$store.state.finder.currentId);
    // Go back to previous question if user uses back chevron
    this.$store.subscribeAction((action) => {
      if (action.type === 'historyBack' && this.$store.state.finder.history.length > 0) {
        this.chooseQuestion(this.$store.state.finder.history.slice(-1)[0]);
        const progressAmount = Math.ceil(this.question.remaining === 0 ? 90 : 100 / this.question.remaining);
        this.setProgressBar(progressAmount);
        // this.setProgressBar(0);
      } else if (action.type === 'restartFinder') {
        this.chooseQuestion(0);
        this.setProgressBar(0);
      }
    });
  },
};
</script>

<style scoped lang="scss">
.finder-container {
  height: 100%;
}

.finder-background {
  background: no-repeat center top;
  background-size: cover;
  height: 100%;
  padding: 60px 0;
}

// Vue animations
.fade-enter-active,
.fade-leave-active {
  transition: all .1s linear;
}

.fade-enter-to {
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: all .3s ease;
}

.slide-enter {
  transform: translateX(100vw);
}

.slide-leave-to {
  transform: translateX(-100vw);
}
</style>
